import $ from 'jquery';

var $navi = $('nav.main-nav');

var toggleNavi = function(toggle) {
    if (toggle !== undefined) {
        $navi.toggleClass('open', toggle);
    } else {
        $navi.toggleClass('open');
    }
};

$(function () {
    $('#header .nav-toggle').click(toggleNavi);
});



/** WEBPACK FOOTER **
 ** /home/rengasturku/nettivanne/nettivanne.git/nettivanne/static/nettivanne/webshop/js/menu.js
 **/